import React from "react";

const About = () => {
  return <div className="container_margin_top">About</div>;
};

export default About;
